import { z } from "zod/v4";

import { CreateOfferDtoSchema, OfferDtoSchema } from "../../../dtos/offers";

export const PostOfferRequestBodySchema = z.object({
  offer: CreateOfferDtoSchema,
});

export type PostOfferRequestBodyType = z.infer<
  typeof PostOfferRequestBodySchema
>;

export const PostOfferResponseBodySchema = z.object({
  offer: OfferDtoSchema,
});

export type PostOfferResponseBodyType = z.infer<
  typeof PostOfferResponseBodySchema
>;
